import * as actionTypes from './actions';
import produce from 'immer';

const initialState = {
  liveVehicles: [],
  liveVehicleEdit: null,
  vehicleFleet: {
    jobs: [],
    statusTypes: []
  },
  dealStatuses: [],
  soldTypes: [],
  liveVehicleMessage: null,
  settlementCost: null,
  liveVehicleFilters: {},
  hasSuccess: false,
  rows: null,
  stats: null,
  targets: null,
  refererUrl: null,
  summary: null,
  weekly_stats: null,
  rentalReport: null,
  saleReport: null,
  successAction: null,
  uploadVehiclesReportSuccess: false,
  uploadVehiclesReportError: false,
  uploadDeliveryReportSuccess: false,
  uploadDeliveryReportError: false,
  fleetStatsReportError: false,
  fleetStatsReportSuccess: false,
  uploadVehicleCheckError: false,
  uploadVehicleCheckSuccess: false,
  generateTasksSuccess: false,
  generateTasksError: false,

  getVehicleMakesSuccess: false,
  getVehicleMakesError: false,
  vehicleMakes: [],


}

const vehicleState = produce((draft = initialState, action) => {
  switch (action.type) {
    case actionTypes.LIVE_VEHICLE_EDIT_SUCCESS:
      draft.liveVehicleEdit = action.data;
      draft.dealStatuses = action.dealStatuses;
      draft.soldTypes = action.soldTypes;
      draft.settlementCost = action.settlementCost;
      break;
    case actionTypes.FLEET_MANAGEMENT_VEHICLE_JOB_SUCCESS:
      draft.vehicleFleet.jobs = action.data.jobs.data;
      draft.vehicleFleet.statusTypes = action.data.statusTypes;
      break;
    case actionTypes.UPDATE_VEHICLE_SUCCESS:
      draft.liveVehicleEdit = action.vehicle;
      draft.liveVehicleMessage = action.message;
      break;
    case actionTypes.UPDATE_VEHICLE_REQUEST:
      draft.liveVehicleMessage = null;
      break
    case actionTypes.SET_FILTERS:
      draft.liveVehicleFilters[action.payload.type] = action.payload.filters;
      break
    case actionTypes.CLEAN_FILTERS:
      draft.liveVehicleFilters[action.payload.type] = {};
      break
    case actionTypes.LIVE_VEHICLE_STATS_SUCCESS:
      draft.rows = action.data.rows;
      draft.stats = action.data.stats;
      break;
    case actionTypes.LIVE_VEHICLE_SAVE__STATS_SUCCESS:
      draft.hasSuccess = true;
      break;
    case actionTypes.LIVE_VEHICLE_SAVE_STATS_REQUEST:
      draft.hasSuccess = false;
      break;
    case actionTypes.MONTHLY_TARGETS_SUCCESS:
      draft.targets = action.data.targets;
      break;
    case actionTypes.SAVE_MONTHLY_TARGETS_REQUEST:
      draft.successAction = null;
      break;
    case actionTypes.SET_REFERER:
      draft.refererUrl = action.payload.referer;
      break
    case actionTypes.CLEAN_REFERER:
      draft.refererUrl = null;;
      break
    case actionTypes.FETCH_MONTHLY_SUMMARY_SUCCESS:
      draft.weekly_stats = action.data.weekly_stats;
      draft.summary = action.data.summary;
      break;
    case actionTypes.FETCH_MONTHLY_SUMMARY_REQUEST:
      draft.weekly_stats = null;
      draft.summary = null;
      break;
    case actionTypes.FETCH_VEHICLE_REPORT_SUCCESS:
      draft.rentalReport = action.data.rentalsReport.sort((a,b) => b.count_model - a.count_model);
      draft.saleReport = action.data.salesReport.sort((a,b) => b.count_model - a.count_model);
      break;
    case actionTypes.FETCH_VEHICLE_REPORT_REQUEST:
      draft.rentalReport = null;
      draft.saleReport = null;
      break;
    case  actionTypes.UPLOAD_MONTHLY_REPORT_TO_DRIVE_REQUEST:
      draft.uploadSuccess = false;
      draft.uploadError = false;
      break;
    case  actionTypes.UPLOAD_MONTHLY_REPORT_TO_DRIVE_SUCCESS:
      draft.uploadSuccess = true;
      draft.uploadError = false;
      break;
    case  actionTypes.UPLOAD_MONTHLY_REPORT_TO_DRIVE_ERROR:
      draft.uploadSuccess = false;
      draft.uploadError = true;
      break;
    case  actionTypes.UPLOAD_VEHICLES_REPORT_TO_DRIVE_REQUEST:
      draft.uploadVehiclesReportSuccess = false;
      draft.uploadVehiclesReportError = false;
      break;
    case  actionTypes.UPLOAD_VEHICLES_REPORT_TO_DRIVE_SUCCESS:
      draft.uploadVehiclesReportSuccess = true;
      draft.uploadVehiclesReportError = false;
      break;
    case  actionTypes.UPLOAD_VEHICLES_REPORT_TO_DRIVE_ERROR:
      draft.uploadVehiclesReportSuccess = false;
      draft.uploadVehiclesReportError = true;
      break;
    case  actionTypes.UPLOAD_DELIVERY_REPORT_TO_DRIVE_REQUEST:
      draft.uploadDeliveryReportSuccess = false;
      draft.uploadDeliveryReportError = false;
      break;
    case  actionTypes.UPLOAD_DELIVERY_REPORT_TO_DRIVE_SUCCESS:
      draft.uploadDeliveryReportSuccess = true;
      draft.uploadDeliveryReportError = false;
      break;
    case  actionTypes.UPLOAD_DELIVERY_REPORT_TO_DRIVE_ERROR:
      draft.uploadDeliveryReportSuccess = false;
      draft.uploadDeliveryReportError = true;
      break;
    case  actionTypes.FLEET_STATS_REPORT_TO_DRIVE_REQUEST:
      draft.fleetStatsReportSuccess = false;
      draft.fleetStatsReportError = false;
      break;
    case  actionTypes.FLEET_STATS_REPORT_TO_DRIVE_SUCCESS:
      draft.fleetStatsReportSuccess = true;
      draft.fleetStatsReportError = false;
      break;
    case  actionTypes.FLEET_STATS_REPORT_TO_DRIVE_ERROR:
      draft.fleetStatsReportSuccess = false;
      draft.fleetStatsReportError = true;
      break;
    case  actionTypes.UPLOAD_VEHICLE_CHECK_TO_DRIVE_REQUEST:
      draft.uploadVehicleCheckSuccess = false;
      draft.uploadVehicleCheckError = false;
      break;
    case  actionTypes.UPLOAD_VEHICLE_CHECK_TO_DRIVE_SUCCESS:
      draft.uploadVehicleCheckSuccess = true;
      draft.uploadVehicleCheckError = false;
      break;
    case  actionTypes.UPLOAD_VEHICLE_CHECK_TO_DRIVE_ERROR:
      draft.uploadVehicleCheckSuccess = false;
      draft.uploadVehicleCheckError = true;
      break;
    case  actionTypes.GENERATE_TASKS_REQUEST:
      draft.generateTasksSuccess = false;
      draft.generateTasksError = false;
      break;
    case  actionTypes.GENERATE_TASKS_SUCCESS:
      draft.generateTasksSuccess = true;
      draft.generateTasksError = false;
      break;
    case  actionTypes.GENERATE_TASKS_ERROR:
      draft.generateTasksSuccess = false;
      draft.generateTasksError = true;
      break;
    case  actionTypes.GET_VEHICLE_MAKES_REQUEST:
      draft.getVehicleMakesSuccess = false;
      draft.getVehicleMakesError = false;
      draft.vehicleMakes=[]
      break;
    case  actionTypes.GET_VEHICLE_MAKES_SUCCESS:
      draft.getVehicleMakesSuccess = true;
      draft.getVehicleMakesError = false;
      draft.vehicleMakes = action.data
      break;
    case  actionTypes.GET_VEHICLE_MAKES_ERROR:
      draft.getVehicleMakesSuccess = false;
      draft.getVehicleMakesError = true;
      draft.vehicleMakes = []
      break;
    case actionTypes.REQUEST_SUCCESS:
      draft.successAction = true;
      break;
    default:
      return draft;
  }
});

export default vehicleState;
